export const AUTH_URL = '/login';
export const STATUS_POPUP_URL = '/status';
